<template>
  <div>
    <div v-if="plans.init === 1">
      <v-layout row wrap class="mb-4">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" v-if="showReview" @click.prevent="promptReselect = true">
          Re-select Plan
          <v-icon right>mdi-pencil</v-icon>
        </v-btn>
      </v-layout>
      <transition name="slide-x-transition" mode="out-in">
        <review-plan v-if="showReview" :travelType="travelForm.travelType" :plan="$store.getters.travelQuoteSelectedPlan" :limitsText="compileLimitsText" :reviewPlanParam="$store.state.agency.quotation.travelParam.reviewPlan" recalcMethodName="travelQuoteRecalculate" @proceed="doProceedReview"></review-plan>
        <div v-else>
          <template v-if="plans.plans.length > 0">
            <v-tabs icons-and-text centered v-model="travelForm.travelType">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab href="#I" v-if="individualPlans.length > 0" key="I">
                Individual
                <v-icon>mdi-account</v-icon>
              </v-tab>
              <v-tab href="#F" v-if="familyPlans.length > 0" key="F">
                Family
                <v-icon>mdi-account-group</v-icon>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="travelForm.travelType">
              <v-tab-item value="I" v-if="individualPlans.length > 0" key="I">
                <common-plans :plans="individualPlans" :limitsText="compileLimitsText" :selected="travelForm.planNo" :currPrefix="currPrefix" iconType="TRAVEL" @selectPlan="doSelectPlan"></common-plans>
              </v-tab-item>
              <v-tab-item value="F" v-if="familyPlans.length > 0" key="F">
                <common-plans :plans="familyPlans" :limitsText="compileLimitsText" :selected="travelForm.planNo" :currPrefix="currPrefix" iconType="TRAVEL" @selectPlan="doSelectPlan"></common-plans>
              </v-tab-item>
            </v-tabs-items>
          </template>
          <template v-else>
            <common-plans :plans="plans.plans" :limitsText="compileLimitsText" :selected="travelForm.planNo" :currPrefix="currPrefix" iconType="TRAVEL" @selectPlan="doSelectPlan"></common-plans>
          </template>
        </div>
      </transition>
      <confirm v-model="promptReselect" @ok="doReselectPlan">
        Are you sure you want to re-select plan? Any plan adjustment will be discarded.
      </confirm>
      <v-layout row wrap class="mt-3">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row wrap class="mb-4">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
      <loader :height="425" :init="doInit" :errorMsgs="plans.initErr" loadText="Loading Plans..." errorText="Failed to load Plans" :loading="plans.init === 0"></loader>
      <v-layout row wrap class="mt-3">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import clone from 'clone'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_TRAVEL_PLANS, QUOTE_TRAVEL_ADJ_CANCEL } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import CommonPlans from '../../shared/plans/CommonPlans'
import ReviewPlan from '../../shared/plans/ReviewPlan'

export default {
  data() {
    return {
      travelForm: {
        planNo: undefined,
        travelType: undefined
      },
      showReview: false,
      promptReselect: false
    }
  },
  computed: {
    plans() {
      return this.$store.state.agency.quotation.travelParam.plans
    },
    individualPlans() {
      let result = []
      if (this.plans.plans && this.plans.plans.length > 0) {
        result = this.plans.plans.filter(x => x.subPlan === 'I')
      }
      return result
    },
    familyPlans() {
      let result = []
      if (this.plans.plans && this.plans.plans.length > 0) {
        result = this.plans.plans.filter(x => x.subPlan === 'F')
      }
      return result
    },
    compileLimitsText() {
      // Need give the main row a main attribute (appearance tweak)
      const result = clone(this.plans.limitsText)
      for (const limit of result) {
        if (limit.value.indexOf('.') === -1) {
          limit.main = true
        }
      }
      return result
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    globalTravelForm() {
      return this.$store.state.agency.quotation.travelForm
    }
  },
  methods: {
    doInit() {
      if (this.plans.init !== 1) {
        this.$store.dispatch('travelQuotePlans')
      }
      this.travelForm.planNo = this.globalTravelForm.planNo
      this.travelForm.travelType = this.globalTravelForm.travelType

      if (this.travelForm.planNo) {
        this.showReview = true
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'travelQuote' })
    },
    doSelectPlan(obj) {
      if (obj) {
        this.travelForm.planNo = obj.value
        if (obj.proceed) {
          this.doProceed()
        }
      }
    },
    doReselectPlan() {
      this.showReview = false
      this.promptReselect = false
      this.$store.commit(QUOTE_TRAVEL_ADJ_CANCEL)
      this.travelForm.planNo = null
    },
    doProceed() {
      if (this.travelForm.planNo) {
        this.$store.commit(QUOTE_TRAVEL_PLANS, this.travelForm)
        this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
        this.$router.push({ name: 'travelQuoteApplicant' })
      } else {
        this.$snotify.error('Please select a Plan')
      }
    },
    doProceedReview() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
      this.$router.push({ name: 'travelQuoteApplicant' })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        // No need commit planNo for save
        // this.$store.commit(QUOTE_TRAVEL_PLANS, this.travelForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
    this.doInit()
  },
  components: {
    CommonPlans,
    ReviewPlan
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
